import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import SocialMediaIcon from './SocialMediaIcon';
import { SocialMedia } from './mappings';

interface Item {
    socialMedia?: SocialMedia;
    link?: string;
}

interface Props {
    items: Array<Item>;
    limit?: number;
}

function formatLabel(value: SocialMedia | string) {
    if (!value) return '';
    const s = String(value);
    return s
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function SocialMediaIconGroup({ items, limit }: Props) {
    const limited = limit ? items.slice(0, limit) : items;
    const remainingLabel = limit
        ? items
            .slice(limit)
            .map((it) => formatLabel(it.socialMedia ?? it.link ?? ''))
            .join(', ')
        : '';

    return (
        <div className='symbol-group symbol-hover flex-nowrap'>
            {limited.map((it, idx) => (
                <OverlayTrigger key={idx} placement='bottom' overlay={<Tooltip>{formatLabel(it.socialMedia ?? it.link ?? '')}</Tooltip>}>
                    <div className='symbol symbol-circle symbol-20px border-light'>
                        <div className='symbol-label p-0'>
                            <SocialMediaIcon socialMedia={it.socialMedia} link={it.link} className='w-100 h-100' />
                        </div>
                    </div>
                </OverlayTrigger>
            ))}
            {limit && items.length > limit && (
                <OverlayTrigger placement='bottom' overlay={<Tooltip>{remainingLabel}</Tooltip>}>
                    <div className={`symbol-label fs-8 fw-bold mt-1`}>+{items.length - limit}</div>
                </OverlayTrigger>
            )}
        </div>
    );
}
